import React from "react"
import Heading from "../heading"
import Hero from "../hero"

const ContactHero = ({ heading, backgroundImageUrl }) => {
  return (
    <Hero page="contact" backgroundImageUrl={backgroundImageUrl}>
      <div className="row align-items-center justify-content-center text-center">
        <div className="col-lg-10 align-self-end">
          {heading ? (
            <Heading className="text-white" divider="light">
              {heading}
            </Heading>
          ) : (
            <div className="py-4" />
          )}
        </div>
      </div>
    </Hero>
  )
}

export default ContactHero
